"use client";
import { jsxs as t, jsx as l } from "react/jsx-runtime";
const o = ({
  title: i,
  titleId: e,
  desc: a,
  descId: n,
  ...r
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": e,
    "aria-describedby": n,
    ...r,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: n, children: a }) : null,
      i ? /* @__PURE__ */ l("title", { id: e, children: i }) : null,
      /* @__PURE__ */ l("path", { fill: "none", d: "M0 0h24v24H0z", opacity: 0.87 }),
      /* @__PURE__ */ l("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" })
    ]
  }
);
export {
  o as default
};
//# sourceMappingURL=CancelOutlined.js.map
